import { useTranslation } from "react-i18next";

import { getFloorById, getPreferences, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { HaNContext } from "../shell/HaNContext";
import { HaNResultList } from "./HaNResultList/HaNResultList";

// Heads the list with the floor its results are on, and says when that's the user's preferred floor
export const SelectedFloorHeader = () => {
  const { t } = useTranslation();
  const { floor } = useRequiredContext(HaNContext);
  const selectedFloor = useAppSelector(state => getFloorById(state, floor.floorId ?? ""));
  const preferredFloorId = useAppSelector(getPreferences).workspaceLocation?.floorId;

  if (!selectedFloor) return null;

  return (
    <HaNResultList.Header title={`${t("Floor")} ${selectedFloor.number}`}>
      {preferredFloorId === selectedFloor.id && <p className="text-mapiq-black-800*">{t("YourPreference")}</p>}
    </HaNResultList.Header>
  );
};
